export const AUTH_ERROR_CODES = {
    REFRESH_TOKEN_FAILED: "RefreshAccessTokenError",
    NOT_AUTHENTICATED: "NotAuthenticated",
} as const;
